import { render, staticRenderFns } from "./OuterList.vue?vue&type=template&id=05d2c7da&scoped=true"
import script from "./OuterList.vue?vue&type=script&lang=js"
export * from "./OuterList.vue?vue&type=script&lang=js"
import style0 from "./OuterList.vue?vue&type=style&index=0&id=05d2c7da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d2c7da",
  null
  
)

export default component.exports